import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { UiSelectComponent, UiSelectOption } from './select.component';

const YEAR_OPTIONS: UiSelectOption[] = [
  { id: 2024, label: '2024' },
  { id: 2025, label: '2025' },
  { id: 2026, label: '2026' },
];

/**
 * Variante de ui-select pre-configurada para selección de año.
 * Opciones fijas: 2024 · 2025 · 2026.
 * Uso: <ui-year-select [(selected)]="selectedYear" />
 */
@Component({
  selector: 'ui-year-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiSelectComponent],
  template: `
    <ui-select
      placeholder="Año"
      [options]="yearOptions"
      [(selected)]="selected"
      [showLabel]="false"
      [showOptionalHint]="false"
      style="width: 120px"
    />
  `,
})
export class UiYearSelectComponent {
  protected readonly yearOptions = YEAR_OPTIONS;
  readonly selected = model<UiSelectOption | null>(null);
}
